import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';
import { BookTestDriveCtaModule } from '../book-test-drive-cta/book-test-drive-cta.module';
import { ButtonModule } from '../button/button.module';
import { ComponentLoaderModule } from '../component-loader/component-loader.module';
import { DynamicValueModule } from '../dynamic-value/dynamic-value.module';
import { ExpansionPanelModule } from '../expansion-panel/expansion-panel.module';
import { FormElementsModule } from '../form-elements/form-elements.module';
import { LeasingConfiguratorModule } from '../leasing/configurator/leasin-configurator.module';
import { LeasingModule } from '../leasing/leasing.module';
import { LinkModule } from '../link/link.module';
import { LoanModule } from '../loan/loan.module';
import { MediaSliderModule } from '../media-slider/media-slider.module';
import { PaymentIconListModule } from '../payment-icon-list/payment-icon-list.module';
import { ProductItemValuationBadgeModule } from '../product/product-item-valuation-badge.module';
import { RichTextModule } from '../rich-text/rich-text.module';
import { TabsModule } from '../tabs/tabs.module';
import { UspModule } from '../usp/usp.module';
import { UtilsModule } from '../utils/utils.module';
import { UsedCarDetailsComponent } from './used-car-details.component';
import { UsedCarSelectedEquipmentComponent } from './used-car-selected-equipment.component';
import { UsedCarFinancingComponent } from './used-car-financing/used-car-financing.component';
import { UsedCarGalleryCtaComponent } from './used-car-hero/used-car-gallery-cta/used-car-gallery-cta.component';
import { UsedCarGalleryComponent } from './used-car-hero/used-car-gallery.component';
import { UsedCarHeroComponent } from './used-car-hero/used-car-hero.component';
import { UsedCarMainDetailsComponent } from './used-car-main-details.component';
import { UsedCarSpecificationsComponent } from './used-car-specifications.component';
import { UsedCarFinancingMotorpointComponent } from './used-car-financing/used-car-financing-motorpoint.component';
import { UsedCarDetailsMotorpointComponent } from './used-car-details-motorpoint.component';
import { UsedCarEquipmentCommentComponent } from './used-car-equipment-comment.component';
import { SectionHeaderModule } from '../section-header/section-header.module';
import { UsedCarFinancingSidebarComponent } from './used-car-financing-sidebar/used-car-financing-sidebar.component';
import { UmbracoGridModule } from '../umbraco-grid/umbraco-grid.module';
import { UsedCarHeroMotorpointComponent } from './used-car-hero/used-car-hero-motorpoint.component';
import { SpotsUiModule } from '../spots/spots-ui.module';

@NgModule({
    declarations: [
        UsedCarDetailsComponent,
        UsedCarDetailsMotorpointComponent,
        UsedCarMainDetailsComponent,
        UsedCarEquipmentCommentComponent,
        UsedCarSelectedEquipmentComponent,
        UsedCarSpecificationsComponent,
        UsedCarHeroComponent,
        UsedCarHeroMotorpointComponent,
        UsedCarGalleryComponent,
        UsedCarGalleryCtaComponent,
        UsedCarFinancingComponent,
        UsedCarFinancingMotorpointComponent,
        UsedCarFinancingSidebarComponent,
    ],
    imports: [
        CommonModule,
        UtilsModule,
        TranslateModule.forChild(),
        LinkModule,
        RouterModule,
        ExpansionPanelModule,
        MediaSliderModule,
        ButtonModule,
        UspModule,
        SwiperModule,
        LoanModule,
        TabsModule,
        RichTextModule,
        PaymentIconListModule,
        BookTestDriveCtaModule,
        ProductItemValuationBadgeModule,
        FormElementsModule,
        FormsModule,
        LeasingModule,
        DynamicValueModule,
        LeasingConfiguratorModule,
        ComponentLoaderModule,
        SectionHeaderModule,
        UmbracoGridModule,
        SpotsUiModule
    ],
    exports: [
        UsedCarDetailsComponent,
        UsedCarDetailsMotorpointComponent,
    ],
})
export class UsedCarDetailsModule {}
